import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { InwardMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchAllPONumbers, fetchPOData } from '../../Store/PHPSlice/Purchase/PoNo';
import { selectAllPONumbers, selectlocationdata, selectPINos, selectPOData, selectRack, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import { createPurInwEntry, fetchPINo } from '../../Store/PHPSlice/Inward/PurchaseInward';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import Dropdown from '../FieldsComponents/Dropdown';


const PurchaseInwardEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        tQtyM: '',
        PoId: '',
        firmId: '',
        amt: '',
        PiNo: '',
        vender: '',
        partyId: '',
        taxAmt: '',
        fAmt: '',
        lrdt: '',
        lrno: '',
        transpt: '',
        bill: '',
        locId: '',
        userId: userdata?.ID
    });
    const [tableRows, setTableRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(null);
    const [openBale, setOpenBale] = useState(false);
    const [noOfBales, setNoOfBales] = useState(0);
    const [rows, setRows] = useState([]);
    const dispatch = useDispatch();
    const polist = useSelector(selectPOData);
    const transptList = useSelector(selectTransports);
    const onlyPonos = useSelector(selectAllPONumbers);
    const PiNo = useSelector(selectPINos);
    const racklist = useSelector(selectRack);
    const loclist = useSelector(selectlocationdata);

    useEffect(() => {
        dispatch(fetchPOData());
        dispatch(fetchTransportData());
        dispatch(fetchAllPONumbers());
        dispatch(fetchPINo());
        dispatch(fetchRackData());
        dispatch(fetchLocationData());
    }, [dispatch]);
    useEffect(() => {
        if (PiNo.data) {
            var Pi = PiNo.data.piNo;
            setFormData((prevFormData) => ({
                ...prevFormData,
                PiNo: Pi
            }));
        }
    }, [PiNo]);

    // console.log(formData.PoId);

    useEffect(() => {
        if (formData.PoId) {
            const selectPos = polist?.data?.filter(item => item.ID === formData.PoId);
            // console.log(selectPos);

            if (selectPos.length > 0) {
                const newData = selectPos
                    .filter(selectPo => parseFloat(selectPo.balMtr) > 0) // only include balMtr > 0
                    .map(selectPo => ({
                        netAmt: parseFloat(selectPo.Amount) + parseFloat(selectPo.igstAmt) + parseFloat(selectPo.cgstAmt) + parseFloat(selectPo.sgstAmt),
                        poInfoId: selectPo.poInfoId,
                        cloth: selectPo.cloth,
                        clothId: selectPo.clothId,
                        rate: selectPo.rate,
                        qty: selectPo.balMtr,
                        inwQty: selectPo.balMtr,
                        balQty: '0',
                        amount: selectPo.Amount,
                        IGST: selectPo.igst,
                        CGST: selectPo.cgst,
                        SGST: selectPo.sgst,
                        IGSTAmt: selectPo.igstAmt,
                        CGSTAmt: selectPo.cgstAmt,
                        SGSTAmt: selectPo.sgstAmt,
                        bale: [],
                        details: '',
                        bcolor: '',
                        poNo: selectPo?.poNo,
                        poId: selectPo?.ID
                    }));


                setTableRows(newData);

                const firstPo = selectPos[0];
                setFormData(prevFormData => ({
                    ...prevFormData,
                    tQtyM: firstPo.tot_mtr,
                    amt: firstPo.amt,
                    taxAmt: firstPo.taxAmt,
                    fAmt: firstPo.finalAmt,
                    vender: firstPo.partyNm,
                    partyId: firstPo.partyId,
                    firmId: firstPo.firmId
                }));
            } else {
                setTableRows([]);
            }
        }
    }, [formData.PoId, polist.data]);


    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };


    const handleRowInputChange = (index, e) => {
        const { name, value } = e.target;
        const updatedRows = tableRows.map((row, i) => (i === index ? { ...row, [name]: value } : row));


        if (name === 'bale') {
            const Id = updatedRows[index].poInfoId; // Extract clothId from the updated row
            setNoOfBales(value);
            setRows(Array.from({ length: value }, () => ({ bale: '', mtr: '0', location: '', Id: Id })));
            setTimeout(() => {
                handleAddButton();
            }, 1000);
        }


        setTableRows(updatedRows);
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.length === 1 && prevSelectedRows[0] === index) {
                // If the checkbox to be deselected is the only selected one, deselect it
                return [];
            } else {
                // Deselect all other checkboxes and select the current one
                return [index];
            }
        });
    };


    // const handleCheckboxChange = (index) => {
    //     setSelectedRows(prevSelectedRows => {
    //         if (prevSelectedRows.includes(index)) {
    //             const prev = prevSelectedRows.filter(rowIndex => rowIndex !== index);
    //             return prev;

    //         } else {

    //             // const selectedRow = tableRows[index];

    //             // let rate = parseFloat(selectedRow.rate) || 0;
    //             // let qty = parseFloat(selectedRow.qty) || 0;
    //             // let amnt = (rate * qty).toFixed(2);
    //             // if (selectedRow.IGSTAmt !== '0') {
    //             //     var taxAmnt = selectedRow.IGSTAmt;
    //             //     var finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // } else {
    //             //     taxAmnt = parseFloat(selectedRow.CGSTAmt) + parseFloat(selectedRow.SGSTAmt);
    //             //     finalAmnt = parseFloat(taxAmnt) + parseFloat(amnt);
    //             // }

    //             // setFormData({
    //             //     ...formData,
    //             //     tQtyM: qty,
    //             //     amt: amnt,
    //             //     taxAmt: taxAmnt,
    //             //     fAmt: finalAmnt,
    //             // });

    //             return [...prevSelectedRows, index];
    //         }
    //     });
    // };


    const handleAddButton = () => {
        setOpenBale(true);
    };

    const handleInputChanged = (index, field, value) => {
        if (field === 'mtr') {
            if (!/^\d*$/.test(value)) {
                return;
            }
        }
        setRows(prevRows => {
            const newRows = [...prevRows];
            newRows[index][field] = value;
            return newRows;
        });
    };

    const handleBaleSubmit = () => {
        const newData = rows.map((item) => (`${item.Id}||${item.bale}||${item.mtr}||${item.location}`));
        const inw_qty = [...rows.map((item) => parseFloat(item.mtr))] || [];
        const sum_inwQty = (inw_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);

        const updatedRows = tableRows.map((ele, index) => {

            if (selectedRows.includes(index)) {
                const amnt = (parseFloat(ele.rate) * sum_inwQty).toFixed(2);
                if (ele.IGSTAmt !== '0') {
                    var igstAmt = ((parseFloat(ele.IGST) * amnt) / 100).toFixed(2) || 0;
                    var net_amt = parseFloat(amnt) + parseFloat(igstAmt);
                } else {
                    var cgstAmt = ((parseFloat(ele.CGST) * amnt) / 100).toFixed(2) || 0;
                    var sgstAmt = ((parseFloat(ele.SGST) * amnt) / 100).toFixed(2) || 0;
                    net_amt = parseFloat(amnt) + parseFloat(cgstAmt) + parseFloat(sgstAmt);
                }
                return {
                    ...ele,
                    details: newData,
                    netAmt: net_amt,
                    inwQty: sum_inwQty,
                    amount: amnt,
                    IGSTAmt: igstAmt || 0,
                    CGSTAmt: cgstAmt || 0,
                    SGSTAmt: sgstAmt || 0,
                };
            }
            return ele;
        });

        setTableRows(updatedRows);
        setOpenBale(false);
        const update_qty = [...updatedRows.map((val) => parseFloat(val.inwQty))] || [];
        const sum_updateQty = (update_qty.reduce((sum, qty) => sum + qty, 0)).toFixed(2);
        const updated_amt = [...updatedRows.map((val) => parseFloat(val.amount))] || [];
        const sum_updateAmt = (updated_amt.reduce((sum, amt) => sum + amt, 0)).toFixed(2);
        const update_igstAmt = [...updatedRows.map((val) => parseFloat(val.IGSTAmt))] || [];
        const sum_igstAmt = update_igstAmt.reduce((sum, igst) => sum + igst, 0);
        const update_cgstAmt = [...updatedRows.map((val) => parseFloat(val.CGSTAmt))] || [];
        const sum_cgstAmt = update_cgstAmt.reduce((sum, cgst) => sum + cgst, 0);
        const update_sgstAmt = [...updatedRows.map((val) => parseFloat(val.SGSTAmt))] || [];
        const sum_sgstAmt = update_sgstAmt.reduce((sum, sgst) => sum + sgst, 0);
        if (sum_igstAmt !== 0) {
            var taxAmt = (sum_igstAmt).toFixed(2);
        } else {
            taxAmt = (sum_cgstAmt + sum_sgstAmt).toFixed(2);
        }

        const final_amt = (parseFloat(sum_updateAmt) + parseFloat(taxAmt)).toFixed(2);
        setFormData(prevFormData => ({
            ...prevFormData,
            tQtyM: sum_updateQty,
            amt: sum_updateAmt,
            taxAmt: taxAmt,
            fAmt: final_amt
        }));

    };
    // console.log(tableRows)
    const handleBaleClick = (index, clothId, inwQty) => {
        setCurrentIndex(index);
        // Construct the URL with query parameters or use a placeholder route
        const id = index + 1;

        const url = `/BaleLumpEntry/${id}-${clothId}-${inwQty}`;
        // console.log(tableRows);
        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1200,height=600,scrollbars=yes,resizable=yes');

        // // Set up a listener to receive data from the child
        // window.addEventListener('message', (event) => {
        //     // Ensure the event comes from the expected source
        //     if (event.origin !== window.location.origin) return;

        //     // Process the data received from the child
        //     // console.log('Data received from child:', event.data);
        //     const updateTable = [...tableRows];
        //     updateTable[index].bale = event.data;
        //     setTableRows(updateTable);
        //     // Update the parent state or perform any required action with the received data
        // });
    };

    // const handleMessage = (event) => {
    //     // Ensure the message is from the same origin
    //     if (event.origin !== window.location.origin) return;

    //     const receivedData = event.data; // Data sent by the child
    //     // console.log("Data received from child:", receivedData);

    //     // Ensure currentIndex and tableRows are valid
    //     if (typeof currentIndex !== "number" || currentIndex < 0 || !tableRows[currentIndex]) {
    //         console.error("Invalid index or tableRows");
    //         return;
    //     }

    //     // Update the table row with the new data
    //     setTableRows((prevTableRows) => {
    //         const updatedTable = [...prevTableRows];
    //         updatedTable[currentIndex].bale = receivedData;
    //         return updatedTable;
    //     });
    // };


    function convertIntoOneObject(array, formData) {
        const mulDetails = [...array.map((item) => item.details)] || [];
        const Qty = [...array.map((item) => parseFloat(item.inwQty))] || [];
        const sum_qty = Qty.reduce((sum, qty) => sum + qty, 0);
        const Amt = [...array.map((item) => parseFloat(item.amount))] || [];
        const sum_amt = Amt.reduce((sum, amt) => sum + amt, 0);
        const igstAmt = [...array.map((item) => parseFloat(item.IGSTAmt))] || [];
        const cgstAmt = [...array.map((item) => parseFloat(item.CGSTAmt))] || [];
        const sgstAmt = [...array.map((item) => parseFloat(item.SGSTAmt))] || [];
        const sum_igstAmt = igstAmt.reduce((sum, igst) => sum + igst, 0);
        const sum_cgstAmt = cgstAmt.reduce((sum, cgst) => sum + cgst, 0);
        const sum_sgstAmt = sgstAmt.reduce((sum, sgst) => sum + sgst, 0);
        const tax_Amt = parseFloat(sum_igstAmt) + parseFloat(sum_cgstAmt) + parseFloat(sum_sgstAmt);
        const final_Amt = sum_amt + tax_Amt;

        const tableData = {
            poInfoId: [...array.map((item) => item.poInfoId)],
            netAmt: [...array.map((item) => item.netAmt)],
            clothNm: [...array.map((item) => item.cloth)],
            clothId: [...array.map((item) => item.clothId)],
            rate: [...array.map((item) => item.rate)],
            qty: [...array.map((item) => item.qty)],
            inwQty: [...array.map((item) => item.inwQty)],
            balQty: [...array.map((item) => item.balQty)],
            amount: [...array.map((item) => item.amount)],
            IGST: [...array.map((item) => item.IGST)],
            CGST: [...array.map((item) => item.CGST)],
            SGST: [...array.map((item) => item.SGST)],
            IGSTAmt: [...array.map((item) => item.IGSTAmt)],
            CGSTAmt: [...array.map((item) => item.CGSTAmt)],
            SGSTAmt: [...array.map((item) => item.SGSTAmt)],
            // bcolor: [...array.map((item) => item.bcolor)],

            details: mulDetails.reduce((acc, curr) => acc.concat(curr), []),

            // Include formData fields

            vender: formData.vender,
            partyId: formData.partyId,
            PoId: formData.PoId,
            dt: formData.dt,
            tQtyM: sum_qty,
            PiNo: formData.PiNo,
            firmId: formData.firmId,
            amt: sum_amt,
            taxAmt: tax_Amt,
            fAmt: final_Amt,
            lrdt: formData.lrdt,
            lrno: formData.lrno,
            transpt: formData.transpt,
            bill: formData.bill,
            locId: formData.locId,
            userId: formData.userId
        };
        return tableData;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const finalObject = convertIntoOneObject(tableRows, formData);
        // console.log(finalObject)

        dispatch(createPurInwEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Purchase Inward Added");
                alert("Purchase Inward Added");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    const handleResend = (resendData) => {
        // console.log("Received data from child window:", resendData);
        if (resendData) {
            const index = resendData?.index;
            const totmtr = resendData?.totmtr;
            const updateTableData = [...tableRows];

            let qty = updateTableData[index].qty;
            let inwQty = updateTableData[index].inwQty;
            let balQty = updateTableData[index].balQty;
            let rate = updateTableData[index].rate;

            inwQty = parseFloat(totmtr);
            balQty = parseFloat(qty) - parseFloat(totmtr);
            const amount = parseFloat(totmtr) * parseFloat(rate);

            updateTableData[index].inwQty = inwQty;
            updateTableData[index].balQty = balQty;
            updateTableData[index].amount = amount;

            const tQtyM = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.inwQty), 0);
            const amt = updateTableData.reduce((acc, qty) => acc + parseFloat(qty.amount), 0);
            const famt = amt + parseFloat(formData.taxAmt);

            setTableRows(updateTableData);
            setFormData(prevFormData => ({
                ...prevFormData,
                tQtyM: tQtyM,
                amt: amt,
                fAmt: famt
            }));
        }
        // Process the data (e.g., update state)
    };

    window.handleResendFromChild = handleResend;

    const dropdownlistfirst = [
        {
            label: 'PO No.',
            id: 'PoId',
            options: onlyPonos?.data?.length > 0 ? onlyPonos?.data : [],
            value: formData.PoId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'PoId', value: newValue ? newValue.ID : '' } }, 'PoId'),
            getOptionLabel: (option) => option.poNo || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value.ID) || null;
                }
                return null;
            },
        }

    ];


    const dropdownlistsecond = [
        {
            label: 'Transport',
            id: 'transpt',
            options: transptList?.data || [],
            value: formData.transpt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'transpt', value: newValue ? newValue.transportNm : '' } }, 'transpt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.transportNm === value.transportNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.transportNm === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Location',
            id: 'locId',
            options: loclist?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }

    ];
    // console.log(onlyPonos?.data)
    return (
        <>
            <Titlebar data={InwardMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Purchase Inward Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="PoId">PO No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="PoId"
                                                    id="PoId"
                                                    name="PoId"
                                                    value={formData.PoId}
                                                    onChange={(e) => handleDropdownChange(e, 'PoId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {onlyPonos.data.length > 0 && onlyPonos.data.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.poNo}</MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {[
                                    { label: 'Total Qty / Meter', name: 'tQtyM', type: 'readOnly' },
                                    { label: 'PI No', name: 'PiNo', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'Date', name: 'dt', type: 'date' },
                                    { label: 'Tax Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Purchase Party', name: 'vender', type: 'readOnly' },
                                    { label: 'Final Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'LR No', name: 'lrno' },
                                    { label: 'LR Date', name: 'lrdt', type: 'date' }

                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.name == 'PoNo' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="transpt">Transport Name :</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="transpt"
                                                    id="transpt"
                                                    name="transpt"
                                                    value={formData.transpt}
                                                    onChange={(e) => handleDropdownChange(e, 'transpt')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        transptList.data.length > 0 ? transptList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.transportNm}>{item.transportNm}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {[
                                    { label: 'Bill/Challan No', name: 'bill' }
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name] || ''}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}


                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>PO No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Color</TableCell> */}
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Mtr.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Inward Mtr.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Bal Mtr.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Bale</TableCell>
                                                        {/* <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Details</TableCell> */}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {tableRows.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.poNo}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            {/* 
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                />
                                                                <input
                                                                    type='text'
                                                                    name="bcolor"
                                                                    value={row.bcolor}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '100px', padding: '2px', outline: 'none' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell> */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly={!selectedRows.includes(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="qty"
                                                                    value={row.qty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="qty"
                                                                    value={row.qty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="inwQty"
                                                                    value={row.inwQty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="inwQty"
                                                                    value={row.inwQty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="balQty"
                                                                    value={row.balQty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="balQty"
                                                                    value={row.balQty}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="bale"
                                                                    value={row.bale}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables, readOnly: !selectedRows.includes(index) }}
                                                                /> */}

                                                                <Button variant="contained" color="primary" size='small'
                                                                    onClick={() => handleBaleClick(index, row.clothId, row.inwQty)}
                                                                    disabled={!selectedRows.includes(index)}
                                                                >
                                                                    Add
                                                                </Button>
                                                            </TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <TextareaAutosize
                                                                    name="details"
                                                                    value={row.details}
                                                                    inputProps={{ style: styled.txtArea, readOnly: true }}
                                                                    style={{ padding: '6px' }}
                                                                />
                                                            </TableCell> */}
                                                        </TableRow>
                                                    ))}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                {openBale && (
                                    <div style={{ margin: '1% 10%' }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Bale</TableCell>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Mtr</TableCell>
                                                    <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align="center">Location</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <TextField
                                                                value={row.bale}
                                                                onChange={(e) => handleInputChanged(index, 'bale', e.target.value)}
                                                                inputProps={{ style: styled.inputTables }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <TextField
                                                                value={row.mtr}
                                                                onChange={(e) => handleInputChanged(index, 'mtr', e.target.value)}
                                                                inputProps={{ style: styled.inputTables }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align="center">
                                                            <Select
                                                                value={row.location}
                                                                onChange={(e) => handleInputChanged(index, 'location', e.target.value)}
                                                                sx={{ width: '200px', height: '30px' }}
                                                            >
                                                                <MenuItem value="">Select an option</MenuItem>
                                                                {racklist.data.length > 0 ? racklist.data.map((item, index) => (
                                                                    <MenuItem key={index} value={item.rackNm}>{item.rackNm}</MenuItem>
                                                                )) : []}
                                                            </Select>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <Button onClick={handleBaleSubmit} variant="contained" color="primary" sx={{ margin: '2% 10%' }}>
                                            Add
                                        </Button>
                                    </div>
                                )}
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default PurchaseInwardEntry;
